export default __webpack_public_path__ + "static/media/loading_spinner.316f9425.gif";